import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Btn from '../btns/Btn'
import Slider from 'react-slick'

function HomeTestimonial({ classes = "" }) {
    let settings = {
        dots: false,
        infinite: true,
        speed: 600,
        autoplay: false,
        autoplaySpeed: 3000,
        arrows: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                }
            },
        ]
    };
    return (
        <>
            <style>{`
            .homeTesti-slider { width: calc(100%  + 24px); margin-left: -12px; position: relative; }
            .homeTesti-slider .slick-list { overflow: visible; }
            .homeTesti-slider  .slick-track { display: flex; }
            .homeTesti-slider .slick-list .slick-slide { height: auto; }
            .homeTesti-slider .slick-list .slick-slide > div { height: 100%; }
            .homeTesti-slider .slick-next { top: calc(50% - 30px); right: 9px; }
            .homeTesti-slider .slick-prev { left: auto; right: 9px; top: calc(50% + 30px); }
            .homeTesti-slider::before { content: ''; position: absolute; width: 50vw; height: calc(100% + 40px); right: 100%; top: -20px; z-index: 1; background-color: #fff; }
            .homeTesti-box::before { content: ''; position: absolute; width: 100%; height: 100%; top: 0; left: 0; -webkit-backdrop-filter: saturate(180%) blur(5px); backdrop-filter: saturate(180%) blur(5px); background: hsla(0, 0%, 100%, .6); }
            .slick-slide.slick-current .homeTesti-box::before { opacity: 0; }
            .bg-gray .homeTesti-slider::before { background-color: rgb(249 249 251 / 80%); }
            .homeTesti-wrapper { position: relative; z-index: 9; }
            .homeTesti-item { padding: 0 12px; height: 100%; }
            .homeTesti-box { background-color: #fff; position: relative; border-radius: 16px; overflow: hidden; padding: 30px 24px; text-align: center; height: 100%; box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); }
            .bg-gray .homeTesti-box { box-shadow: none; }
            .homeTesti-quote { font-size: 18px; }
            .homeTesti-icon { width: 60px !important; margin: 0 auto 16px; }
            .homeTesti-icon img { width: 100%; }
            .homeTesti-auth { width: 60px; margin: 0 auto 16px; height: 60px; border-radius: 50%; overflow: hidden; }
            .homeTesti-auth img { width: 100%; }
            .homeTesti-by h4 { font-size: 18px; color: #555; margin: 0; }
            @media (max-width:991.98px) {
                .homeTesti-wrapper { margin-bottom: 40px; }
            }
            @media (max-width:767.98px) {
                .homeTesti-slider .slick-slider { padding-right: 50px; padding-bottom: 30px; }
                .homeTesti-slider .slick-next, .homeTesti-slider .slick-prev { right: -10px; }
                .homeTesti-icon { width: 40px !important; }
                .homeTesti-quote { font-size: 16px; }
                .homeTesti-auth { width: 50px; height: 50px; }
                .homeTesti-by h4 { font-size: 16px; }
                .homeTesti-box::before { display: none; }
            }
        `}</style>
            <div className={`section-padding homeTesti-container overflow-hidden ${classes}`}>
                <Container>
                    <Row className='align-items-center' data-aos="fade-up">
                        <Col lg={4}>
                            <div className="homeTesti-wrapper pe-lg-4">
                                <div className="heading  mb-lg-0">
                                    <h6><span>What client says</span></h6>
                                    <h3>Client <span>Testimonials</span> About Xipe Tech </h3>
                                    <p>Xipe Tech transformed our business with their dedication, innovative solutions, and unparalleled expertise. They're our go-to for all things digital</p>
                                </div>
                                <div className="mt-3">
                                    <Btn route="/contact-us/" type={"default"} value="Contact" />
                                </div>
                            </div>
                        </Col>
                        <Col lg={8} className='mx-auto'>
                            <div className="homeTesti-slider">
                                <Slider {...settings}>
                                    <div className='homeTesti-item'>
                                        <div className="homeTesti-box">
                                            <div className="homeTesti-icon">
                                                <img src="../assets/images/testimonials/fe_quote-left.png" alt="" />
                                            </div>
                                            <div className="homeTesti-quote">
                                                <blockquote>The programmer is a genuine hard-working developer. He works to high standards and always communicated every day with updates. I will work with him again as I like his attitude.</blockquote>
                                            </div>
                                            <div className="homeTesti-by">
                                                <div className="homeTesti-auth">
                                                    <img src="../assets/images/testimonials/test-1.jpg" alt="" />
                                                </div>
                                                <h4>Dave - UK</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='homeTesti-item'>
                                        <div className="homeTesti-box">
                                            <div className="homeTesti-icon">
                                                <img src="../assets/images/testimonials/fe_quote-left.png" alt="" />
                                            </div>
                                            <div className="homeTesti-quote">
                                                <blockquote>To be honest, Mach provided me with a very high quality of work. Higher than what I expected. He always keeps me updated every hour, really enjoy working with him I recommend him for HTML 5</blockquote>
                                            </div>
                                            <div className="homeTesti-by">
                                                <div className="homeTesti-auth">
                                                    <img src="../assets/images/testimonials/test-1.jpg" alt="" />
                                                </div>
                                                <h4>PSD to HTML (Sam)</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='homeTesti-item'>
                                        <div className="homeTesti-box">
                                            <div className="homeTesti-icon">
                                                <img src="../assets/images/testimonials/fe_quote-left.png" alt="" />
                                            </div>
                                            <div className="homeTesti-quote">
                                                <blockquote>What can I say? I am used to buying templates from Themeforest. But this time I wanted to try out a custom design. To do so I hired XIPE TECH to slice my design and add ...</blockquote>
                                            </div>
                                            <div className="homeTesti-by">
                                                <div className="homeTesti-auth">
                                                    <img src="../assets/images/testimonials/test-1.jpg" alt="" />
                                                </div>
                                                <h4>The WhiteLabel</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='homeTesti-item'>
                                        <div className="homeTesti-box">
                                            <div className="homeTesti-icon">
                                                <img src="../assets/images/testimonials/fe_quote-left.png" alt="" />
                                            </div>
                                            <div className="homeTesti-quote">
                                                <blockquote>Xipe Tech Team is very professional and has point-blank developers. Definitely will hire them again. The Xipe Tech team was very communicative about the issues we had and had the knowledge to point out them. Great ...</blockquote>
                                            </div>
                                            <div className="homeTesti-by">
                                                <div className="homeTesti-auth">
                                                    <img src="../assets/images/testimonials/test-1.jpg" alt="" />
                                                </div>
                                                <h4>Zend Client - UK</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='homeTesti-item'>
                                        <div className="homeTesti-box">
                                            <div className="homeTesti-icon">
                                                <img src="../assets/images/testimonials/fe_quote-left.png" alt="" />
                                            </div>
                                            <div className="homeTesti-quote">
                                                <blockquote>Xipe Tech team was very good at communication and managed the project professionally. Look forward to working with them again. Xipe Tech completed the assigned…</blockquote>
                                            </div>
                                            <div className="homeTesti-by">
                                                <div className="homeTesti-auth">
                                                    <img src="../assets/images/testimonials/test-1.jpg" alt="" />
                                                </div>
                                                <h4>Squarespace - Australia</h4>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='homeTesti-item'>
                                        <div className="homeTesti-box">
                                            <div className="homeTesti-icon">
                                                <img src="../assets/images/testimonials/fe_quote-left.png" alt="" />
                                            </div>
                                            <div className="homeTesti-quote">
                                                <blockquote>Xipe Tech team was very quick, was very patient with my short brief, understand what I need quickly. I will hire them again.</blockquote>
                                            </div>
                                            <div className="homeTesti-by">
                                                <div className="homeTesti-auth">
                                                    <img src="../assets/images/testimonials/test-1.jpg" alt="" />
                                                </div>
                                                <h4>CI - Malaysia</h4>
                                            </div>
                                        </div>
                                    </div>
                                </Slider>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default HomeTestimonial